import Resource from '@/api/resources/Resource'
import i18n from '@/lang/i18n'

class CustomNotificationsService extends Resource {
    async getAllCustomSentNotifications(laboratoryId, caseId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/customNotifications`)
        return response.data
    }
    async sendPredefinedCustomNotification(laboratoryId, caseId, predefinedCustomNotificationId) {
        const response = await this.axios.post(`/laboratories/${laboratoryId}/cases/${caseId}/customNotifications/sendPredefined`, null, { params: predefinedCustomNotificationId })
        return response.data
    }
    async sendTailoredCustomNotification(laboratoryId, caseId, sendRequest, attachReport) {
        const response = await this.axios.post(`/laboratories/${laboratoryId}/cases/${caseId}/customNotifications/sendTailored?attachReport=${attachReport}`, sendRequest)
        return response.data
    }
}

export const CUSTOM_NOTIFICATION_TYPE = () => ({
    CASE: { code: 'CASE', name: i18n.tc('entities.case.case') },
    SAMPLE: { code: 'SAMPLE', name: i18n.tc('entities.sample.sample') }
})

export default new CustomNotificationsService()
